export const parseData = (data: any[] | any) => {
  return Array.isArray(data) ? arrayToObject(data) : data;
};

export const arrayToObject = (arr: any[], key: string = 'id') => {
  return arr.reduce((acc, item) => {
    acc[item[key]] = item;
    return acc;
  }, {});
};
